let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lfZ13")).then(() => parcelRequire('kIaEk'));